import { ReactElement } from "react";

export function Instruction({
    icon,
    title,
    description,
}: {
    icon: ReactElement;
    title: string;
    description: string;
}) {
    return (
        <div className="flex-1 p-6 overflow-auto flex items-center justify-center">
            <div className="max-w-2xl w-full bg-gray-50 rounded-lg shadow-md border border-base-300 p-8 text-center">
                <div className="flex flex-col items-center justify-center mb-6">
                    <div className="bg-gray-100 p-5 rounded-full mb-4">
                        {icon}
                    </div>
                    <h2 className="text-xl font-bold text-gray-700 mb-2">
                        {title}
                    </h2>
                    <p className="text-gray-600">{description}</p>
                </div>
            </div>
        </div>
    );
}
